import { render, staticRenderFns } from "./Home.bakCopy.vue?vue&type=template&id=1e71a79c&scoped=true"
import script from "./Home.bakCopy.vue?vue&type=script&lang=js"
export * from "./Home.bakCopy.vue?vue&type=script&lang=js"
import style0 from "./Home.bakCopy.vue?vue&type=style&index=0&id=1e71a79c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e71a79c",
  null
  
)

export default component.exports